import { render, staticRenderFns } from "./advertisementType.vue?vue&type=template&id=5c76513e&"
import script from "./advertisementType.vue?vue&type=script&lang=js&"
export * from "./advertisementType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports